import { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography
} from '@material-ui/core';



//Redux
import { useSelector, useDispatch } from "react-redux";
import { SET_CALCULATOR  } from '../../redux/actions/types';


//My COmponent
import Slider from 'src/components/calculator/Slider'
import Rate from 'src/components/calculator/Rate'
import PayTerm from 'src/components/calculator/PayTerm'


const LoanGen = (props) => {
  const [values, setValues] = useState([0, 1000, 2000]);
    const [payterm, setPayTerm] = useState([0, 1, 5]);

    const dispatch = useDispatch();
    const { calculator } = useSelector(state => state.data);

    const handlePayTerms = (data) => {
      let vals = payterm;
      vals[1] = data[0] !== payterm[0] ? data[0] : data[2] !== payterm[2] ? data[2] : data[1] === payterm[0] || data[1] === payterm[2] ? payterm[1] : data[1] ;
      setPayTerm(vals);
      dispatch({
        type: SET_CALCULATOR,
        payload: { term: vals[1] }
      })
    }

    const handleAmount = (data) => {
      let val = values;
      val[1] = data;
      setValues(val);
      dispatch({
        type: SET_CALCULATOR,
        payload: { principal: val[1] }
      })
    }

  return (
    <Card {...props}>
    <CardHeader title="Loan Generator" />
    <Divider />
    <CardContent>
        <Box
          sx={{
            display: 'block',
            justifyContent: 'center',
            p: 1
          }}
        >
            <Rate />
            <br/>
            <PayTerm
            STEP={1}
            MIN={0}
            MAX={5}
            type={calculator.rateTerm === 'Weekly' ? 'Week/s' : calculator.rateTerm === 'Monthly' ? 'Month/s' : 'Semi-monthly Periods'}
            values={payterm}
            setValues={handlePayTerms}
           />
                <Slider
            STEP={500}
            MIN={1000}
            MAX={2000}
            values={values[1]}
            def={values[1]}
            handleValue={handleAmount}
           />
        </Box>
      </CardContent>
      <Divider/>
      <Box
          sx={{
            display: 'block',
            justifyContent: 'center',
            p: .5
          }}
        >
          <Typography variant="h6" className="text-center text-danger">NOTE</Typography>
          <p className="text-center font-sm p-2">
            Please prepare your payment before the due date to avoid late payment charges.
          {/* , consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,  */}
          {/* quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. */}
          </p>
        </Box>
    </Card>
  );
};

export default LoanGen;
